'use client';
import { FC, PropsWithChildren, ReactNode } from 'react';
import Entering from './Entering';
import Typography from './Typography';

interface ICardsGridBanner {
  cards?: {
    title: string;
    icon?: ReactNode;
  }[];
}

const CardsGridBanner: FC<PropsWithChildren<ICardsGridBanner>> = ({ cards = [] }) => (
  <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
    {cards?.map(({ title, icon }, index) => (
      <Entering
        initial={false}
        damping={20}
        mass={0.5}
        stiffness={120}
        delay={index * 0.2}
        key={title}
        className="rounded-6xl border border-tolq-gray-100 bg-white p-6 !pb-4"
      >
        <div className="flex h-[200px] items-center justify-center bg-tolq-green-300">{icon}</div>
        <div className="flex w-full justify-center pt-3">
          <Typography variant="bold1" className="text-center text-tolq-black-100">
            {title}
          </Typography>
        </div>
      </Entering>
    ))}
  </div>
);

export default CardsGridBanner;
